import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000"
}
function ShiSpe128({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M.7 0H0v68.1h1.2V0H.7z"
                    id="ShiSpe128__Symbol_309_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ShiSpe128__Symbol_309_0_Layer0_0_FILL"
                transform="translate(191.9 249.5)"
                id="ShiSpe128__col1n"
            />
        </g></g>
    )
}
export default ShiSpe128
